
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addStaff } from '../../../actions/staff';
import UserApi from '../../../API/user/user-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1, Text, TextGrey } from '../../../components/Basic/WrapsStyle';
import ReasonTypeWrap from '../../../components/Shipments/WrapStyle/ReasonType';
import { TYPE_BUTTONS, WAREHOUSES } from '../../../constans';
import { getDate } from '../../../utils/index';
import { MARKETS_LIST } from '../../Shipments/Shipment';
import DisputeAnswerPenaltyPopUp from '../../User/PeriodFinancesPage/PopUps/DisputeAnswerPenalty';
import styles from './styles.module.scss';

const FILTER = {
  0: 'all',
  1: 'penalty_during',
  2: 'penalty_approved',
  3: 'penalty_denied',
};
const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const WIDTH = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '300px', // 3
];

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 60 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const PenaltyPage = () => {
  const dispatch = useDispatch();
  const staff = useSelector((store) => store.staff);

  let [userSelect, setUserSelect] = useState('');

  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [postings, setPostings] = useState({ ids: [], byId: {} });

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const [checkAll, setCheckAll] = useState(false);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [checkupResponse, setCheckupResponse] = useState(undefined);

  const [penalties, setPenalties] = useState([]);
  const [penaltyType, setPenaltyType] = useState({ name: 'Не выбран', value: undefined });

  const allProviders = useSelector((store) => store.providers);

  const [map, setMap] = useState({});
  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [providers, setProviders] = useState([]);
  const [period, setPeriod] = useState({ start: new Date(moment().subtract(2, 'year')), end: CalcFeatureTwoDay() });
  let [penaltyMap, setPenaltyMap] = useState({});
  let [usersMap, setUsersMap] = useState({});
  let [openStornoAnswerWindow, setOpenStornoAnswerWindow] = useState({ state: false, penalty: {} });

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState({ links: [], index: 0 });

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const params = useMemo(() => {
    const shop_name = shopName === 'Все' ? '' : shopName;

    return {
      search: search.trim(),
      page,
      limit: parseInt(show),
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      filters: {
        isNotPenalty: penaltyType.value
      },
      tab: FILTER[tab],
    };
  }, [search, show, page, tab, provider.id, marketMany, shopName, period, sklad, checkupResponse, penaltyType]);

  const openImageViewer = (images, index) => {
    setImages({ links: images, index });
    setIsViewerOpen(true);
  };

  const loadCards = () => {
    UserApi.getUserPenalties({ data: params }).then((r) => {

      setPenalties(r.penalties);
      setPenaltyMap({ ...r.postingsMap, ...r.reservedMap, ...r.warehouseMap });

      setUsersMap(r.usersMap);
      setProductsSelect({});
      setCheckAll(false);
      setCountStock([r.tabs?.all, r.tabs?.penalty_during, r.tabs?.penalty_approved, r.tabs?.penalty_denied]);

      setCount(r.count);
    });

    return () => { };
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
  }, []);

  const packeres = staff.filter((user) => user.role === 'packer');

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <>
      <Content>
        <H1>Штрафы</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все штрафы', 'На рассмотрении', 'Согласован возврат', 'Не согласован возврат']}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
            <Row></Row>
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(productsSelect).length > 0 ? (
              <Row className={styles.row_select}>
                <Button
                  type={TYPE_BUTTONS.RED}
                  style={{ marginRight: '15px' }}
                  onClick={() => {
                    setCheckAll(false);
                    setPostingsPrint({});
                  }}
                >
                  Очистить выбор
                </Button>
              </Row>
            ) : (
              <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
            )}
          </Row>
          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>
          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '35px' }}
              />
              <Select
                label="Тип штрафа"
                select={penaltyType}
                list={[{ name: 'Не выбран', value: undefined }, { name: 'Штраф', value: null }, { name: 'Удержание', value: true },]}
                valueFn={(p) => p?.name}
                onSelect={(v) => setPenaltyType(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </Row>
            <Row>
              <Column style={{ marginRight: '10px' }}>
                <InputLabel>Начало периода</InputLabel>
                <Row style={{ width: '130px' }}>
                  <DateInput
                    value={period.start}
                    className={styles.calendar}
                    onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                  />
                </Row>
              </Column>
              <Column style={{ marginRight: '10px' }}>
                <InputLabel>Конец периода</InputLabel>
                <Row style={{ width: '130px' }}>
                  <DateInput
                    value={period.end}
                    className={styles.calendar}
                    onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                  />
                </Row>
              </Column>
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>
        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Дата штрафа
            </HeaderTitle>

            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Источник
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Номер заказа / Артикул
            </HeaderTitle>
            <HeaderTitle width={WIDTH[3]} centerText={true}>
              Описание
            </HeaderTitle>
            <HeaderTitle width={WIDTH[2]} centerText={true}>
              Фото
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Cумма
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Кому штраф
            </HeaderTitle>
            <HeaderTitle width={WIDTH[0]} centerText={true}>
              Статус возврата штрафа
            </HeaderTitle>
            <HeaderTitle width={WIDTH[3]} centerText={true}>
              Комментарий
            </HeaderTitle>
          </TableHeader>

          {penalties
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map((penalty) => {
              const data = penalty;
              const from = data.from;
              const item = penaltyMap[data.reserve_id || data.posting_number || data.warehouse_id];
              let checkup = {};
              let artnumber_posting = '';
              let reason = '';
              if (from === 'postings') {
                artnumber_posting = penalty.posting_number;
                //console.log('postings find checkup', item.checkups);
                checkup = item.checkups?.find((ch) => ch._id === data.checkup_id);
                reason = checkup?.reason?.type;
              }
              if (from === 'reserves') {
                artnumber_posting = item.warehouse_id;
                reason = 'Проверка резервов';
              }
              if (from === 'warehouse') {
                artnumber_posting = item.id;
                reason = 'Проверка склада';
              }

              let penalty_user = usersMap[penalty.userId];

              return (
                <TableLine key={penalty._id}>
                  <TableCell width={WIDTH[0]} center>
                    {getDate(penalty.date)}
                  </TableCell>

                  <TableCell width={WIDTH[0]} center>
                    <ReasonTypeWrap reason={reason} />
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {artnumber_posting}
                  </TableCell>
                  <TableCell width={WIDTH[3]}>{penalty.solution}</TableCell>
                  <TableCell width={WIDTH[2]} center>
                    <Column>
                      <div className={styles.div_line_images}>
                        {checkup?.response?.links.slice(0, 3).map((link, index) => {
                          return (
                            <div className={styles.wrapper} key={link}>
                              <img
                                onClick={() => openImageViewer(checkup?.response?.links, index)}
                                className={styles.preview}
                                src={link.length > 0 ? link : undefined}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </Column>
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    <Column style={{ alignItems: 'center' }}>
                      <Text className={styles.red}>- {penalty.sum} ₽</Text>
                      <TextGrey fontSize={12} style={{ textAlign: 'center', fontSize: '12px' }}>
                        {penalty.sum_desc}
                      </TextGrey>
                    </Column>
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {penalty_user?.name}
                  </TableCell>
                  <TableCell width={WIDTH[0]} center>
                    {data.annulation?.is_annuled && (
                      <>
                        {data.annulation?.return_sum == data.sum ? (
                          <span className={styles.green}>Возврат штрафа согласован</span>
                        ) : (
                          <span className={styles.blue}>Возврат штрафа частично согласован</span>
                        )}
                      </>
                    )}
                    {data.annulation?.is_annuled === false && (
                      <span className={styles.red}>Возврат штрафа не согласован</span>
                    )}
                    {data.protest?.length > 0 && !data.annulation && (
                      <span className={styles.yellow}>На расмотрении</span>
                    )}
                  </TableCell>
                  <TableCell width={WIDTH[3]} center>
                    <Column>
                      {data.protest?.length > 0 && (
                        <div style={{ textAlign: 'left' }}>
                          <span>Сотрудник:</span> {data.protest}
                        </div>
                      )}

                      {data.annulation?.return_sum_desc?.length > 0 && (
                        <div style={{ textAlign: 'left' }}>
                          <span>Проверяющий:</span>
                          {data.annulation?.return_sum_desc}{' '}
                          {data.annulation?.is_annuled && (
                            <span>{`возврат ${data.annulation.return_sum}₽  ${getDate(
                              data.annulation?.date_annuled,
                            )}`}</span>
                          )}
                        </div>
                      )}
                    </Column>
                  </TableCell>
                  {/* && !data.annulation */}
                  {isOwner && data.protest?.length > 0 && !data.annulation && (
                    <TableCell width={WIDTH[0]} center>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => setOpenStornoAnswerWindow({ state: true, penalty: data, penalty_user })}
                        disabled={data.protest?.length === 0}
                      >
                        Ответить
                      </Button>
                    </TableCell>
                  )}
                </TableLine>
              );
            })}
          {/* {postings.ids.map((order) => {
            return (
              <TableSKKShipmentLine
                isAdmin={isAdmin}
                tab={tab}
                type={'Отгрузки'}
                order={postings.byId[order]}
                map={map}
                key={postings.byId[order].posting_number}
                onChangeProduct={onChangeProduct}
              />
            );
          })} */}
        </Table>
        {openStornoAnswerWindow.state && (
          <DisputeAnswerPenaltyPopUp
            user={openStornoAnswerWindow.penalty_user}
            penalty={openStornoAnswerWindow.penalty}
            close={() => {
              setOpenStornoAnswerWindow({ state: false, penalty: {} });
              loadCards();
            }}
          />
        )}
      </Content>
    </>
  );
};

export default PenaltyPage;
